//import  './components/dropdown';
import Dropdown from './components/poi/dropdown';
//import './components/tab';
import Tab from './components/poi/tab';
//import './components/language-selector';
import './components/poi/language-selector';
//import './components/select';
import Select from './components/poi/select';
import './components/lazysizes';
//import './components/pristine';
import './components/countdown';
import './components/show-password-button';
//import './components/quantity';
import Quantity from './components/poi/quantity';
import './components/accordion';
import './components/fancybox';
//import './components/collapse';
import Collapse from './components/poi/collapse';
//import './components/dialog';
import Dialog from './components/poi/dialog';
//import './components/datePicker';
import './components/poi/datePicker';
import './components/verify-code';
import './components/file-upload';
import './components/copy-button';
import './components/tippy';
import './components/rangeSlider';
import toastr from './components/notification';

import './objects/hero-slider';
//import './objects/ticket-slider';
import './objects/poi/ticket-slider';
import './objects/card-slider';
import './objects/product-gallery';
import './objects/related-products';
//import './objects/product-form';
import './objects/product-card';
//import './objects/filter-form';
import './objects/card-block-slider';
import './objects/address-form';
//import './objects/payment-method-form';
//import './objects/media-gallery';
import './objects/poi/media-gallery';
import './objects/awards-slider';
//import './objects/event-items';
import './objects/aid-logos';
//import './objects/card';
import './objects/poi/card';
import './objects/ticket-picker';
import './objects/guest-picker';
import './objects/return-request-form';
import './objects/animation';
import './objects/card-slider-video';
import './objects/poi/language-selector-dialog';

//import Quantity from "./components/poi/quantity";
//import Tab from "./components/poi/tab";
//import Dialog from "./components/poi/dialog";
import {Datepicker} from "vanillajs-datepicker";
import en from 'vanillajs-datepicker/locales/en-GB';
import ru from 'vanillajs-datepicker/locales/ru';
import de from 'vanillajs-datepicker/locales/de';
import tr from 'vanillajs-datepicker/locales/tr';
Object.assign(Datepicker.locales, en, tr, de, ru);
//import Select from "./components/poi/select";
//import Collapse from "./components/poi/collapse";
//import Dropdown from "./components/poi/dropdown";


window.Quantity = Quantity;
window.Tab = Tab;
window.Dialog = Dialog;
window.Datepicker = Datepicker;
window.Select = Select;
window.Collapse = Collapse;
window.Dropdown = Dropdown;
window.toastr = toastr;